<script setup>
import GenericModal from './GenericModal.vue';

const emit = defineEmits(['close']);

const close = () => emit('close');
</script>
<template>
  <generic-modal @close="close">
  <template v-slot:content>
    <div
      class="
        bg-ford-gray-light
        w-full tablet:max-w-[40rem]
        h-full tablet:max-h-[17.5rem]
      ">
      <div class="w-full flex justify-end">
        <button
          @click="close"
          class="mx-[0.5rem] text-2xl"
        >&times;</button>
      </div>
      <div class="p-[1rem] tablet:px-[4rem] tablet:py-[3rem]">
        <slot name="body"></slot>
      </div>
    </div>
  </template>
  </generic-modal>
</template>
